import React, { Component } from 'react';

class Loader extends Component {
    render() {
        return (
            <div className="preloader">
                <span className="loader">
                    <span className="loader-inner"></span>
                </span>
            </div>
        );
    }
}

export default Loader;